import state from './moduleCustomerState'
import actions from './moduleCustomerActions'
import getters from './moduleCustomerGetters'
import mutations from './moduleCustomerMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
